import React from 'react';

export const UnsafeHTML = ({html, ...props}) => {
    return html && <div {...props} dangerouslySetInnerHTML={{__html: html}}></div>
    }
